/**
 * Created by gcuellar on 20/04/17.
 */
import {Directive, ElementRef, OnInit, Input} from '@angular/core';
import {HasPermissionService} from "./hasPermission.service";


@Directive({
    selector: '[hasPermission]'
})
export class HasPermissionDirective implements OnInit {

    @Input() hasPermission: any;

    constructor(private el: ElementRef,
                private permissionService: HasPermissionService) {
    }

    ngOnInit() {
        this.el.nativeElement.removeAttribute('ng-reflect-has-permission')
        if (typeof this.hasPermission !== 'string')
            throw 'hasPermission value must be a string';
        let Modules = this.hasPermission.trim();
        if (!this.permissionService.hasPermission(Modules))
            this.el.nativeElement.remove()
    }

}
